import { path } from 'ramda';
import { DesignTokensType } from '..';

/** Types **/
type PathsToStringProps<T> = T extends string | number
  ? []
  : {
      [K in Extract<keyof T, string>]: [K, ...PathsToStringProps<T[K]>];
    }[Extract<keyof T, string>];

type Join<T extends string[], D extends string> = T extends []
  ? never
  : T extends [infer F]
    ? F
    : T extends [infer F, ...infer R]
      ? F extends string
        ? `${F}${D}${Join<Extract<R, string[]>, D>}`
        : never
      : string;

type DotSeparatedThemeVariable = Join<
  PathsToStringProps<DesignTokensType>,
  '.'
>;

/**
 * convenient, type-safe way of quickly referencing theme values in
 * styled-components
 */
export const tvar =
  <K extends DotSeparatedThemeVariable>(key: K) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (props: any): string =>
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    path(
      key.split('.'),
      'theme' in props ? props.theme : props['shared'] || {},
    ) as string;
